export default __webpack_public_path__ + "static/nikon_logo.inline-fae5f084162e98a27da08b82b5f57dbd.png";